import { Component } from '@angular/core';
import { CreditNoteListComponent } from '../list/credit-note-list.component';
import { CreditNoteRestService } from '../credit-note-rest.service';
import { BaseListBComponent } from '../../../libraries/base/list/base-list.bcomponent';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'app-detail-modal',
  templateUrl: './detail-modal.component.html'
})
export class DetailModalComponent extends BaseListBComponent<any> {
  tableColumns = [
    {
      i18nLabel: 'ui.creditNote.detail.entity.month',
      field: 'date',
      sort: true
    },
    {
      i18nLabel: 'ui.creditNote.detail.entity.category',
      field: 'category',
      sort: true
    },
    {
      i18nLabel: 'ui.creditNote.detail.entity.quantity',
      field: 'quantity',
      sort: true
    },
    {
      i18nLabel: 'ui.creditNote.detail.entity.revenue',
      field: 'revenue',
      sort: true
    },
    {
      i18nLabel: 'ui.creditNote.detail.entity.deductedAmount',
      field: 'deductedAmount',
      sort: true
    },
    {
      i18nLabel: 'ui.creditNote.detail.entity.remainingCredit',
      field: 'remainingCredit',
      sort: true
    },
    {
      i18nLabel: 'ui.creditNote.detail.entity.note',
      field: 'note',
      sort: true
    },
    {
      i18nLabel: 'ui.creditNote.detail.entity.createdBy',
      field: 'createdBy',
      sort: true
    },
    {
      i18nLabel: 'ui.creditNote.detail.entity.createdAt',
      field: 'createdAt',
      sort: true
    }
  ];
  tableColumnsShow: boolean = false;
  tableColumnsToggle = this._gridTableToggle.mapToggleOptionsFromColumns(this.tableColumns);

  listComponent: CreditNoteListComponent;
  isModalOpen = false;
  mainDealerId: string;

  constructor(private api: CreditNoteRestService) {
    super();
    this.componentId = 'CreditNoteDetailModalComponent';
  }

  appDefineFixedHooks() {
    super.appDefineFixedHooks();

    this.registerHook({
      hookName: 'loadData',
      handle: event => {
        const qOption = event.data.qOption;
        qOption['limit'] = qOption['take'];
        delete qOption['take'];
        delete qOption['skip'];
        const qParams = Object.assign({}, event.data.qParams, qOption, this.qParams);
        if (!this.mainDealerId) {
          return of({ data: [] });
        }
        return this.api.getByDealerId(this.mainDealerId, qParams).pipe(
          switchMap(doc => {
            const dataFormatted = doc?.data?.map((d: any) => ({
              ...d,
              date: moment(d?.date).format('MMMM'),
              revenue: this.formatRupiah(d?.revenue),
              category: d.category.replaceAll('_', ' '),
              deductedAmount: this.formatRupiah(d?.deductedAmount),
              remainingCredit: this.formatRupiah(d?.remainingCredit),
              createdBy: d?.createdBy || '-',
              createdAt: moment(d?.createdAt).format('DD MMMM YYYY')
            }));

            doc.data = dataFormatted;
            return of(doc);
          })
        );
      },
      wrapRetryableTask: true,
      wrapErrorMessage: true
    });

    this.registerHook({
      hookName: 'init',
      handle: () => this.page.compHookService?.callMultipleHooks(['CreditNoteDetailModalComponent:workflowLoadData'])
    });
  }

  appOnInit() {
    super.appOnInit();

    return this.callHook('init');
  }

  // Open the modal
  openModal(mainDealerId: string): void {
    this.isModalOpen = true;
    this.mainDealerId = mainDealerId;
    this.page.compHookService
      .callHook('CreditNoteDetailModalComponent:workflowLoadData', {
        qOption: this.getDefaultQueryOption(),
        qParams: this.qParams
      })
      .subscribe();
  }

  // Close the modal
  closeModal(): void {
    this.isModalOpen = false;
    this.mainDealerId = null;

    this.page.compHookService
      .callHook('CreditNoteDetailModalComponent:workflowLoadData', {
        qOption: this.getDefaultQueryOption(),
        qParams: this.qParams
      })
      .subscribe();
  }
}
